<template>
 <!-- https://github.com/SelfhostedPro/Yacht/blob/master/frontend/src/views/Applications.vue -->
  <div class="">
    <!-- <transition
      name="slide"
      enter-active-class="animated slideInRight delay"
      leave-active-class="animated slideOutLeft"> -->
      <router-view />
    <!-- </transition> -->
  </div>
</template>

<script>
export default {}
</script>

<style lang="css"></style>
